import { AccessTypeEnum } from "requests";

export const ACCESS_TYPES = {
  [AccessTypeEnum.LogIn]: "Log In",
  [AccessTypeEnum.LogInPin]: "Log In using PIN",
  [AccessTypeEnum.LogOut]: "Log Out"
};
